import { Dispatch, SetStateAction } from "react";
import { XButtonForm } from "../XButtonForm";

interface Props {
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  placeholder?: string;
  extraClass?: string;
}

const SearchInput = ({ search, setSearch, placeholder, extraClass }: Props) => {
  return <div className="relative h-[30px] w-full flex justify-center">
    <img
      className="absolute left-[20px] top-[50%] translate-y-[-50%]"
      src="/images/icon/search.png" />
    <input
      className={`w-[90%] h-full rounded-[22px] pl-[30px]
      border-[1.5px] border-blue-dark/35 focus:outline-none 
      leading-[16px] text-gray-900 font-medium ${extraClass}`}
      placeholder={placeholder}
      value={search}
      onChange={(e) => setSearch(e.target.value)} />
	  
	  <XButtonForm
	  		className="right-[15px]"
			onClick={() => {
				if (search) {
					setSearch('');
				}
			}}
		/>

  </div>
}

export default SearchInput;